(() => {
  const source = document.getElementById('sens-product-spec-data');
  if (!source) return;
  const product = JSON.parse(source.textContent);
  let timer;
  function update() {
    const input = document.querySelector('product-form[data-main="true"] form [name="id"]') || document.querySelector('form[action$="/cart/add"] [name="id"]');
    const id = input?.value || new URL(location.href).searchParams.get('variant') || product.selected;
    const variant = product.variants.find(v => String(v.id) === String(id));
    if (!variant) return;
    document.querySelectorAll('.sens-spec-panel[data-sens-sku]').forEach(panel => {
      const show = panel.dataset.sensSku === variant.sku;
      if (panel.hidden === show) panel.hidden = !show;
    });
    const panels = document.querySelectorAll('.sens-spec-panel');
    if (panels.length) return;
    const holder = document.getElementById('sens-auto-specs');
    if (!holder) return;
    if(holder.dataset.variantId===String(variant.id))return;
    holder.dataset.variantId=String(variant.id);
    const text = (variant.title === 'Default Title' ? '' : variant.title) + ' ' + product.title;
    const rows = [['Marka',product.vendor],['Ürün kodu',variant.sku]];
    const cpu = text.match(/(?:Core\s*)?Ultra\s*[3579][ -]*\d{3}[A-Z]?|Core\s*[3579][ -]*\d{3}[A-Z]?|i[3579][ -]*\d{4,5}[A-Z]*|Ryzen\s*(?:AI\s*)?[3579][ -]*\d+[A-Z]*|R[3579][ -]*\d{4}[A-Z]*/i);
    if (cpu) rows.push(['İşlemci',cpu[0]]);
    const memory = text.match(/\b(\d+)\s*(?:GB|G)\b/i);
    if (memory) rows.push(['RAM',memory[1]+' GB']);
    const disk = [...text.matchAll(/\b(\d+)\s*(GB|TB|SD|SSD)\b/gi)].find(m => /TB|SD|SSD/i.test(m[2]) || Number(m[1])>=128);
    if (disk) rows.push(['Depolama',disk[1]+' '+(/TB/i.test(disk[2])?'TB':'GB')+' SSD']);
    const screen = product.title.match(/(\d+(?:[.,]\d+)?)\s*(?:"|″|'')/);
    if (screen) rows.push(['Ekran boyutu',screen[1]+' inç']);
    const os = text.match(/Windows\s*11\s*Pro|Windows\s*Pro|W11PRO|WPro|WPr|W11H|Ubuntu|FreeDOS|DOS/i);
    if(os) rows.push(['İşletim sistemi',/W11H/i.test(os[0])?'Windows 11 Home':/WPr|Windows.*Pro/i.test(os[0])?'Windows 11 Pro':os[0]]);
    holder.hidden = rows.length <= 2;
    const body = holder.querySelector('tbody');
    body.replaceChildren(...rows.filter(r=>r[1]).map(([key,value])=>{
      const row=document.createElement('tr'),th=document.createElement('th'),td=document.createElement('td');
      th.scope='row';th.textContent=key;td.textContent=value;row.append(th,td);return row;
    }));
  }
  function schedule() {clearTimeout(timer);timer=setTimeout(update,150);}
  update();
  document.addEventListener('change',schedule);
  window.addEventListener('popstate',schedule);
  new MutationObserver(schedule).observe(document.getElementById('MainContent'),{childList:true,subtree:true});
})();
